
























































































































































































































































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { PolicyDataInfo } from '../../utils';

@Component
export default class PrivacyPolicyNlFirst extends Vue {
    @Prop({ type: Object, required: true}) private formData!: PolicyDataInfo
}
